let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j9yw3")).then(() => parcelRequire('02V19'));